import createGetFormNames from './selectors/getFormNames';
import plain from './structure/plain';
export default createGetFormNames(plain);


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/getFormNames.js
// module id = Uqjz
// module chunks = 1